import { render, staticRenderFns } from "./CloudDeclarations.vue?vue&type=template&id=7fb361c9&scoped=true&"
import script from "./CloudDeclarations.vue?vue&type=script&lang=js&"
export * from "./CloudDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./CloudDeclarations.vue?vue&type=style&index=0&id=7fb361c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb361c9",
  null
  
)

export default component.exports